module.exports = __webpack_public_path__ + "a3e57ed6c4cefefa9acb6877e71e55da.svg";